import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../../api/spacing/injectSpacing.mjs.mjs";
export const StyledDividerWrap = styled.div.withConfig({ displayName: "auir-611444a-StyledDividerWrap", componentId: "auir-611444a-1jbh8o2" }) `
  ${injectSpacing('margin')}
`;
export const StyledDisclamer = styled.div.withConfig({ displayName: "auir-611444a-StyledDisclamer", componentId: "auir-611444a-1icjllf" }) `
  font-family: var(${(props) => props.theme.fontFamily});
  font-size: var(
    ${(props) => props.theme.responsive.typography.copy2.fontSize}
  );
  margin: 0;
  button {
    font-size: var(
      ${(props) => props.theme.responsive.typography.copy2.fontSize}
    );
  }
`;
export const StyledDisclamerWrapper = styled.div.withConfig({ displayName: "auir-611444a-StyledDisclamerWrapper", componentId: "auir-611444a-1ae8tpn" }) `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
//# sourceMappingURL=ExtendedSelectionToolbar.styles.mjs.mjs.map